import React from "react";
import {
  Head,
  WeekCalendarOne,
} from "../../components";
import "./my_schedule.css";

export const My_schedule = () => {
  return (
    <>
      <div className="my_schedule-g">
        <Head title="My schedule" />
        <WeekCalendarOne />
      </div>
    </>
  );
};

export default My_schedule;
